import * as React from 'react';
import './membership-withdrawal-modal.scss';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import CheckBox from '../../../common/checkbox/checkbox';
import Button from '../../../common/button/button';

interface Props {
    onClose: Function;
    withdraw: Function;
}

const MembershipWithdrawalModal: React.FC<Props> = ({ onClose, withdraw }) => {
    const [check, setCheck] = React.useState<boolean>(false);

    const onClick = () => {
        onClose(false);
    };

    const onClickWithdraw = () => {
        if (check) {
            withdraw();
        }
    };

    const checkboxToggle = () => {
        setCheck(!check);
    };

    return (
        <>
            <div className="membership-withdrawal-modal">
                <div className="membership-withdrawal-modal-content">
                    <div className="membership-withdrawal-modal-content__modal-action">
                        <div className="modal-action__close" onClick={onClick}>
                            <Close />
                        </div>
                    </div>
                    <div className="membership-withdrawal-modal-content__head">회원탈퇴</div>
                    <div className="membership-withdrawal-modal-content__text">
                        <div>-삭제된 계정은 되돌릴 수 없습니다.</div>
                        <div>-영구적으로 계정을 삭제하기전에 충분한 검토바랍니다.</div>
                        <div>-현재 사용중인 요금제가 있다면 해당일이 지난후 자동 탈퇴처리됩니다.</div>
                    </div>
                    <div className="check-box">
                        <CheckBox
                            checked={checkboxToggle}
                            text="데이터를 모두 삭제하고 탈퇴하겠습니다."
                            defaultCheck={check}
                            isRed={true}
                        />
                    </div>
                    <div className="membership-withdrawal-modal-content-buttons">
                        <div className="membership-withdrawal-modal-content-buttons__cancel">
                            <Button label="취소" type="type1" action={onClick} />
                        </div>
                        <div className="membership-withdrawal-modal-content-buttons__success">
                            <Button label="탈퇴" type={check ? 'type2' : 'type10'} action={onClickWithdraw} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default MembershipWithdrawalModal;
